import React from "react";

const SquareLogo = ({ size = 35 }) => {
  return (
    <div
      style={{
        width: size,
        height: size,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "transparent",
        overflow: "hidden",
      }}
    >
      <img
        src={require("../data/media/logo.png")}
        alt="Logo"
        style={{
          maxWidth: "95%",
          maxHeight: "95%",
          objectFit: "contain",
          width: "auto",
          height: "auto",
          imageRendering: "high-quality",
        }}
      />
    </div>
  );
};

export default SquareLogo;
